/* src/app/_shared/components/header/header.component.scss */
:host {
  display: block;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
}
header {
  width: 100%;
  min-height: 52px;
  padding-top: var(--safe-area-top);
  background-color: #FFFFFF;
}
/*# sourceMappingURL=header.component.css.map */
